import * as tslib_1 from "tslib";
import openCompose from './openCompose';
import trySaveAndCloseCompose from './trySaveAndCloseCompose';
import datapoints from '../datapoints';
import composeStore from '../store/composeStore';
import buildReplyForwardMessageBody from '../utils/buildReplyForwardMessageBody';
import ComposeTarget from '../store/schema/ComposeTarget';
import createItemIdForRequest from '../utils/createItemIdForRequest';
import getDefaultBodyType from '../utils/getDefaultBodyType';
import getDocumentId from '../utils/getDocumentId';
import getReplyForwardSubject from '../utils/getReplyForwardSubject';
import isEncryptionFeatureEnabled from '../utils/isEncryptionFeatureEnabled';
import { MailboxType } from 'owa-client-ids';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import createItem from 'owa-mail-store/lib/services/createItem';
import createResponseFromModernGroupItem from 'owa-mail-store/lib/services/createResponseFromModernGroupItem';
import store from 'owa-mail-store/lib/store/Store';
import forwardItem from 'owa-service/lib/factory/forwardItem';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
import { userMailInteractionAction } from 'owa-mail-actions';
export default action('forwardMessage', datapoints.MailComposeForward)(select({
    referenceItem: function (referenceClientItemId) {
        return store.items.get(referenceClientItemId.Id);
    },
    defaultViewState: function () { return composeStore.defaultViewState; },
})(function forwardMessage(referenceClientItemId, actionSource, instrumentationContexts, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var openInTab, referenceItem, bodyType, composeOperation, documentId, referenceItemId, item, timeFormat, mailboxInfo, groupId, message, composeInitProps, createForwardResponse, _a, responseMessage, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    openInTab = isTabViewEnabled();
                    if (!!openInTab) return [3 /*break*/, 2];
                    return [4 /*yield*/, trySaveAndCloseCompose(null /*viewState*/)];
                case 1:
                    _c.sent();
                    // If there is still default compose viewstate, it means it is failed to save and close previous compose
                    // So no-op here
                    if (state.defaultViewState) {
                        return [2 /*return*/, Promise.resolve()];
                    }
                    _c.label = 2;
                case 2:
                    referenceItem = state.referenceItem;
                    bodyType = getDefaultBodyType();
                    composeOperation = 3 /* Forward */;
                    documentId = getDocumentId(referenceItem);
                    referenceItemId = createItemIdForRequest(referenceItem.ItemId);
                    item = forwardItem({
                        ReferenceItemId: referenceItemId,
                        ReferenceItemDocumentId: documentId,
                        Subject: getReplyForwardSubject(referenceItem, false /*isReply*/),
                    });
                    timeFormat = getUserConfiguration().UserOptions.TimeFormat;
                    mailboxInfo = referenceClientItemId.mailboxInfo;
                    groupId = mailboxInfo && mailboxInfo.type == MailboxType.GroupMailbox
                        ? mailboxInfo.mailboxId
                        : null;
                    composeInitProps = {
                        operation: composeOperation,
                        bodyType: bodyType,
                        subject: item.Subject,
                        referenceItemId: referenceItem.ItemId,
                        referenceItemDocumentId: documentId,
                        preferAsyncSend: true,
                        IRMData: isEncryptionFeatureEnabled()
                            ? referenceItem.RightsManagementLicenseData
                            : null,
                        useSmartResponse: true,
                    };
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 8, , 9]);
                    if (!groupId) return [3 /*break*/, 5];
                    return [4 /*yield*/, createResponseFromModernGroupItem(item, bodyType, false /*isSend*/, timeFormat)];
                case 4:
                    _a = _c.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, createItem(item, bodyType, false /*isSend*/, timeFormat)];
                case 6:
                    _a = _c.sent();
                    _c.label = 7;
                case 7:
                    createForwardResponse = _a;
                    responseMessage = createForwardResponse.ResponseMessages
                        .Items[0];
                    message = responseMessage.Items[0];
                    composeInitProps.itemId = message.ItemId;
                    composeInitProps.quotedBody = buildReplyForwardMessageBody(message.Body.Value, bodyType);
                    composeInitProps.attachments = message.Attachments;
                    composeInitProps.useSmartResponse = false; // Quoted body is loaded, no need to use smart response now
                    return [3 /*break*/, 9];
                case 8:
                    _b = _c.sent();
                    return [3 /*break*/, 9];
                case 9: return [4 /*yield*/, openCompose(composeInitProps, openInTab ? ComposeTarget.SecondaryTab : ComposeTarget.PrimaryReadingPane, groupId)];
                case 10:
                    _c.sent();
                    userMailInteractionAction('Forward', instrumentationContexts);
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=forwardMessage.js.map